import {useEffect, useState} from "react";
import {ProductService} from "./Service";
import toast from "react-hot-toast";
import Select from "react-select";
import {nanoid} from 'nanoid'
import {UploadService} from "../../utils/Upload";

const AddProduct = () => {
    const uploadService = new UploadService();
    const [service] = useState(new ProductService()); // [state, setState
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState(0);
    const [color, setColor] = useState('');
    const [type, setType] = useState(null);
    const [parent, setParent] = useState(null);
    const [parentOptions, setParentOptions] = useState([]);
    const typeOptions = [
        {value: 'Simple Card', label: 'Simple Card'},
        {value: 'Google Review Card', label: 'Google Review Card'},
        {value: 'Custom Card', label: 'Custom Card'},
    ];
    const [loading, setLoading] = useState(false);
    // File Upload
    const [selectedfile, SetSelectedFile] = useState([]);
    const [Files, SetFiles] = useState([]);

    const filesizes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    const InputChange = (e) => {
        // --For Multiple File Input
        let images = [];
        for (let i = 0; i < e.target.files.length; i++) {
            images.push((e.target.files[i]));
            let reader = new FileReader();
            let file = e.target.files[i];
            reader.onloadend = () => {
                // @ts-ignore
                SetSelectedFile((preValue) => {
                    return [
                        ...preValue,
                        {
                            id: nanoid(),
                            filename: e.target.files[i].name,
                            filetype: e.target.files[i].type,
                            fileimage: reader.result,
                            datetime: e.target.files[i].lastModifiedDate.toLocaleString('en-IN'),
                            filesize: filesizes(e.target.files[i].size),
                            file: file
                        }
                    ]
                });
            }
            if (e.target.files[i]) {
                reader.readAsDataURL(file);
            }
        }
    }


    const DeleteSelectFile = (id) => {
        if (window.confirm("Are you sure you want to delete this Image?")) {
            const result = selectedfile.filter((data) => data.id !== id);
            SetSelectedFile(result);
        } else {
            // alert('No');
        }

    }


    const DeleteFile = async (id) => {
        if (window.confirm("Are you sure you want to delete this Image?")) {
            const result = Files.filter((data) => data.id !== id);
            SetFiles(result);
        } else {
            // alert('No');
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        toast.loading('Adding product...');
        const images = [];
        for (let i = 0; i < selectedfile.length; i++) {
            const res = await uploadImage((selectedfile[i]).file);
            if (res) {
                images.push(res);
            }
        }
        const data = {
            title,
            description,
            price,
            color,
            type: type.value,
            parent: parent ? parent.value : null,
            images: images
        }
        const res = await service.add(data);
        toast.dismiss();
        if (res) {
            toast.success('Product added successfully');
            setLoading(false);
            e.target.reset();
            setTitle('');
            setDescription('');
            setPrice(0);
            setColor('');
            setType(null);
            setParent(null);
            SetSelectedFile([]);
            SetFiles([]);
        }

    }

    const uploadImage = async (file) => {
        const res = await uploadService.upload(file);
        return res.length > 0 ? res[0] : null;
    }

    const fetchParentOptions = async () => {
        const res = await service.all();
        if (res) {
            setParentOptions(res.filter(item => !item.parent).map(item => {
                return {
                    value: item._id,
                    label: item.title
                }
            }));
        }
    }

    useEffect(() => {
        fetchParentOptions();
    }, [])


    return (
        <>
            <div className="card">
                <div className="card-header p-3">
                    <h5 className="card-title">Add Product</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Title <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="title" name="title"
                                           placeholder="Product name"
                                           value={title}
                                           onChange={(e) => setTitle(e.target.value)} required={true}/>
                                </div>
                            </div>
                            <div className="mb-3 col-sm-12 col-md-4">
                                <label htmlFor="type" className="form-label">Type <span
                                    className='text-danger'>(required)</span></label>
                                <Select
                                    name="type"
                                    options={typeOptions}
                                    value={type}
                                    onChange={setType} required={true}/>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="price" className="form-label">Price <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="number" className="form-control" id="price" name="price"
                                           placeholder="Price" value={price}
                                           onChange={(e) => setPrice(parseInt(e.target.value))} required={true}/>
                                </div>
                            </div>
                            <div className="mb-3 col-sm-12 col-md-4">
                                <label htmlFor="parent" className="form-label">Parent</label>
                                <Select
                                    name="parent"
                                    options={parentOptions}
                                    value={parent}
                                    onChange={setParent}/>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Color</label>
                                    <input type="text" className="form-control" id="color" name="color"
                                           placeholder="Product color" value={color}
                                           onChange={(e) => setColor(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Description</label>
                                    <textarea className="form-control" id="description" name="description"
                                              placeholder="Product description" value={description}
                                              onChange={(e) => setDescription(e.target.value)}/>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <label htmlFor="images" className="form-label">Images</label>
                            </div>

                            <div className="col-12">
                            <div className="fileupload-view">
                                    <div className="row justify-content-center m-0">
                                        <div className="kb-data-box">
                                            <div className="kb-file-upload">
                                                <div className="file-upload-box">
                                                    <input type="file" id="fileupload"
                                                           className="file-upload-input"
                                                           onChange={InputChange} multiple/>
                                                    <span>Drag and drop or <span
                                                        className="file-link">Choose your files</span></span>
                                                </div>
                                            </div>
                                            <div className="kb-attach-box mb-3">
                                                {
                                                    selectedfile.map((data, index) => {
                                                        const {
                                                            id,
                                                            filename: any,
                                                            filetype,
                                                            fileimage,
                                                            datetime,
                                                            filesize
                                                        } = data;
                                                        return (
                                                            <div className="file-atc-box" key={id}>
                                                                {
                                                                    data.filename.match(/.(jpg|jpeg|png|gif|svg)$/i) ?
                                                                        <div className="file-image"><img
                                                                            src={fileimage} alt=""/></div> :
                                                                        <div className="file-image"><i
                                                                            className="far fa-file-alt"></i>
                                                                        </div>
                                                                }
                                                                <div className="file-detail">
                                                                    <h6>{data.filename}</h6>
                                                                    <p></p>
                                                                    <p><span>Size : {filesize}</span><span
                                                                        className="ml-2">Modified Time : {datetime}</span>
                                                                    </p>
                                                                    <div className="file-actions">
                                                                        <button type="button"
                                                                                className="file-action-btn"
                                                                                onClick={() => DeleteSelectFile(id)}>Delete
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {Files.length > 0 ?
                                                <div className="kb-attach-box">
                                                    <hr/>
                                                    {
                                                        Files.map((data, index) => {
                                                            const {
                                                                id,
                                                                filename: any,
                                                                filetype,
                                                                fileimage,
                                                                datetime,
                                                                filesize
                                                            } = data;
                                                            return (
                                                                <div className="file-atc-box" key={index}>
                                                                    {
                                                                        data.filename.match(/.(jpg|jpeg|png|gif|svg)$/i) ?
                                                                            <div className="file-image"><img
                                                                                src={fileimage} alt=""/></div> :
                                                                            <div className="file-image"><i
                                                                                className="far fa-file-alt"></i>
                                                                            </div>
                                                                    }
                                                                    <div className="file-detail">
                                                                        <h6>{data.filename}</h6>
                                                                        <p><span>Size : {filesize}</span><span
                                                                            className="ml-3">Modified Time : {datetime}</span>
                                                                        </p>
                                                                        <div className="file-actions">
                                                                            <button className="file-action-btn"
                                                                                    onClick={() => DeleteFile(id)}>Delete
                                                                            </button>
                                                                            <a href={fileimage}
                                                                               className="file-action-btn"
                                                                               download={data.filename}>Download</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                : ''}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={'d-flex'}>
                            <button type="submit" className="btn btn-primary me-2" disabled={loading}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Submit
                            </button>
                            <button type="button" className="btn btn-secondary me-2" disabled={loading} onClick={() => {
                                window.history.back();
                            }}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Back
                            </button>
                        </div>

                    </form>

                </div>
            </div>
        </>
    );
}


export default AddProduct;
